<template>
  <div class="treeBox">
    <el-input
      size="small"
      v-if="isSearch"
      :placeholder="$t('common.searchTip')"
      v-model="filterText"
    >
    </el-input>
    <el-tree
      class="filter-tree"
      :data="tree"
      :indent="0"
      node-key="label"
      :highlight-current="false"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterNode"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      ref="tree"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="isPrimaryKey('ORGANIZAMANAGEMENT_ADD')" @click.native="addNode(node)"
                >{{ $t("common.btn.add") }}</el-dropdown-item>
              <el-dropdown-item v-if="isPrimaryKey('ORGANIZAMANAGEMENT_EDIT')" @click.native="editNode(node)">{{ $t("common.btn.edit") }}</el-dropdown-item>
              <el-dropdown-item v-if="isPrimaryKey('ORGANIZAMANAGEMENT_DELETE')" @click.native="deleteNode(node)"
                >{{ $t("common.btn.delete") }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  data() {
    return {
      provincialCenterId: "",
      filterText: "",
      tree: [],
      defaultProps: {
        children: "children",
        label: "value",
      },
      companyId: "",
    };
  },
  props: ["isSearch", "treeData"],
  created() {
    this.init();
  },
  methods: {
    init() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        companyId: sessionStorage.getItem("companyId"),
      };
      this.$store.dispatch("tree/GET_QUERYTREE", param).then((res) => {
        if (res.data) {
          let routeParam = {};
          routeParam.id = res.data.data[0].label;
          routeParam.name = res.data.data[0].value;
          routeParam.level = res.data.data[0].level;
          this.tree = res.data.data;
          this.$emit("initFun", routeParam);
        }
      });
    },
    handleNodeClick(data, node) {
      this.$emit("nodeClick", data);
    },
    filterNode(value, data) {
      console.log(value, data)
      if (!value) return true;
      return data.value.indexOf(value) !== -1;
    },

    addNode(node) {
      this.$prompt('请输入节点名称', '新增',
        {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
        }).then(res => {
          let param = { 
            upid: node.data.label,
            name: res.value,
            level: node.data.level
           }
          this.$store.dispatch('tree/GET_INSERTTREE', param).then(response => {
            if (response.data.code == 200) {
              this.init()
              this.$message.success(this.$t('common.btn.addSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
      
    },
    
    deleteNode(node) {
      console.log(node)
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(res => {
          let param = { id: node.data.label }
          this.$store.dispatch('tree/GET_DELETETREE', param).then(response => {
            if (response.data.code == 200) {
              this.init()
              this.$message.success('删除成功')
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },
    
    editNode(node) {
      console.log(node)
      this.$prompt('请输入节点名称', '修改',
        {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
         
        }).then(res => {
          let param = { 
            id:node.data.label,
            name: res.value,
           }
          this.$store.dispatch('tree/GET_UPDATETREE', param).then(response => {
            if (response.data.code == 200) {
              this.init()
              this.$message.success('修改成功')
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },
  },
  watch: {
    filterText(val) {
      var newVal = val.trim()
      this.$refs.tree.filter(newVal);
    },
  },
};
</script>

<style lang="less" scoped>
.treeBox {
  text-align: center;
  padding: 20px;
  /deep/.el-input {
    width: 90%;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-color: #c6cdd5;
      border-radius: 0;
      padding: 0 10px;
      background: transparent;
      color: #fff;
    }
  }
  /deep/.el-tree {
    width: 95%;
    display: inline-block;
    background-color: transparent;
    color: #fff;
    padding-top: 10px;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: rgba(74, 145, 218, 0.5);
      color: #fff;
    }
    .el-tree-node:focus > .el-tree-node__content {
      background-color: rgba(74, 145, 218, 0.5);
    }
    .el-tree-node__content:hover {
      background-color: rgba(74, 145, 218, 0.5);
      color: #fff;
    }
    .el-tree-node__label {
      font-size: 14px;
    }
    .el-tree-node__expand-icon.expanded {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    .el-tree-node__content > .el-tree-node__expand-icon {
      padding: 6px 10px;
    }
    .el-icon-caret-right:before {
      background: url("../assets/images/open.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node__expand-icon.is-leaf::before {
      background: none !important;
    }
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      background: url("../assets/images/close.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node__expand-icon.is-leaf::before {
      background: url("../assets/images/open.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node {
      position: relative;
      padding: 0 18px;
    }
    .el-tree-node :last-child:before {
      height: 34px;
    }
    .el-tree-node:before {
      border-left: none;
    }
    .el-tree-node:after {
      border-top: none;
    }
    .el-tree-node:before,
    .el-tree-node:after {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  }
}
</style>